<template>
  <div class="section-container">
    <div class="main-container clearfix">
      <floating></floating>
      <div class="page__title">
        <h2 class="large__title">产品信息</h2>
        <h4 class="small__title square">PRODUCT INFO</h4>
      </div>
      <div class="detail">
          <div class="recommend__identify">
            <h3><img :src="picPc"></h3>
            <h4 class="title__en">Professional real estate finance</h4>
            <h4 class="title__ch">专业的房产金融服务</h4>
            <!-- <img :src="item.picPc" :alt="item.name"> -->
          </div>
          <div class="detail-content">
            <h3>{{productName}}</h3>
            <p class="detail-summary">{{summary}}</p>
            <p class="details">
              {{explain}}
            </p>
          </div>
          <div class="detailBtn-wrap">
            <button class="detailBtn" @click="onClick">立即申请借款</button>
          </div>
      </div>
      <div class="row">
        <div class="row-side text-center">
          <h1>申请条件</h1>
        </div>
        <div class="paragraph-wrapper">
          <div class="item">
            <div class="item-title"></div>
            <p v-for="(item, index) in apply" :key="index">{{item.title}}: {{item.content}}</p>
          </div>
        </div>
        <div class="row-side text-center">
          <h1>适用人群</h1>
        </div>
        <div class="paragraph-wrapper">
          <div class="item">
            <div class="item-title"></div>
            <p v-for="(item, index) in application" :key="index">{{item.title}}: {{item.content}}</p>
          </div>
        </div>
        <div class="row-side text-center">
          <h1>所需材料</h1>
        </div>
        <div class="paragraph-wrapper">
          <div class="item">
            <div class="item-title"></div>
            <p v-for="(item, index) in material" :key="index">{{item.content}}</p>
          </div>
        </div>
      </div>
      <modal :show="show" @dismiss="show=false" class="borrow-dialog">
        <div class="modal-wrap">
          <div class="page-caption">
            <h3 class="title">申请借款</h3>
          </div>
          <form class="form-horizontal form-custom" @submit.prevent="submitHandler" novalidate="novalidate">
            <div class="form-group">
              <label class="control-label col-xs-4">借款金额：</label>
              <div class="col-xs-8">
                <div class="input-group">
                  <input class="form-control" type="text" v-model.number="money" ref="input" placeholder="">
                  <span class="input-group-addon">元</span>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="control-label col-xs-4">借款期限：</label>
              <div class="col-xs-8">
                <div class="input-group">
                  <input class="form-control" type="text" v-model.number="duration" placeholder="">
                  <span class="input-group-addon">天</span>
                </div>
              </div>
            </div>
            <div class="btn-wrap">
              <p class="err-wrap">{{errmsg}}<span>&nbsp;</span></p>
              <button type="submit" class="btn btn-primary">确&nbsp;&nbsp;定</button>
            </div>
          </form>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
  import Modal from '@/components/modal/modal'
  import Floating from '@/components/combo/floating'

  export default {
    name: 'BorrowDetail',
    components: {Modal, Floating},
    data () {
      return {
        show: false,
        errmsg: '',
        productName: '',
        summary: '',
        explain: '',
        picPc: '',
        application: [],
        apply: [],
        material: [],
        money: 0,
        checkMoney: null,
        moneyMsg: '',
        duration: 0
      }
    },
    created () {
      this.productId = this.$route.params.id
      this._fetchData()
    },
    watch: {
      show (val) {
        if (val) {
          this.$nextTick(() => {
            this.money = 0
            this.duration = 0
            this.errmsg = ''
            this.$refs.input.focus()
          })
        }
      },
      money: 'onChange',
      duration: 'onChange',
      '$store.state.city' () {
        this.$router.push(`/borrow`)
      }
    },
    methods: {
      _fetchData () {
        let vm = this
        this.$http({
          url: '/getProductExplainByPid.jhtml',
          data: {
            productId: this.productId
          },
          done (data) {
            data = data || {}
            // 产品信息
            vm.productName = data.productName || ''
            vm.summary = data.summary || ''
            vm.explain = data.explain || ''
            vm.picPc = data.picPc || ''
            // 适用人群
            vm.application = data.application || []
            // 申请条件
            vm.apply = data.apply || []
            // 所需材料
            vm.material = data.material || []
          }
        })
      },
      isRealNameVerify () {},
      onClick () {
        if (this.$store.state.token) {
          let vm = this
          let token = this.$store.state.token
          this.$http({
            url: '/center/isRealNameVerify.jhtml',
            data: {
              uid: token.uid
            },
            done (d, p, r) {
              if (d === 0) {
                vm.$router.push('/authentication')
              } else {
                vm.show = true
              }
            }
          })
        } else {
//          this.$store.commit('changeLogin', true)
          this.$router.push('/login')
        }
      },
      onChange (val) {
        if (val) {
          this.errmsg = ''
        }
      },
      validate () {
        let rules = {
          money: {
            patterns: [{
              pattern: this.$validate.patterns.money,
              msg: '请输入正确的金额'
            }],
            required: '请输入借款金额'
          },
          duration: {
            patterns: [{
              pattern: /^[1-9][0-9]*$/,
              msg: '请输入正确的期限'
            }],
            required: '请输入借款期限'
          }
        }
        let msgField = 'errmsg'
        return this.$validate({rules, msgField})
      },
      submitHandler (e) {
        if (this.validate()) {
          let vm = this
          let token = this.$store.state.token
          this.$http({
            url: '/center/addOrder.jhtml',
            data: {
              uid: token.uid,
              money: this.money,
              duration: this.duration,
              productId: this.productId
            },
            done (d, p, r) {
              vm.show = false
              let path = '/u/order'
              let msg = r.msg
              if (/\d/.test(d) && d > -1) {
                path = `/u/profile/${d}`
                msg = '您的订单已提交，<br>请完善您的收款信息！'
              }
              vm.$dialog(msg, () => {
                vm.$router.push(path)
              })
            }
          })
        }
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../../stylus/mixin'
.main-container
  padding 46px 0 0 0
.page__title
  .large__title
    letter-spacing 16px
  .small__title
    padding-left 120px
    &:after
      margin-left -87px
      width 70px
.detail
  position relative
  margin 0 auto
  margin-top 81px
  width 1180px
  height 306px
  background-color #fff
  box-shadow: 0 1px 15px 3px rgba(0,0,0,0.16)
  border-radius 5px
  padding 23px 50px 0
  .recommend__identify
    border-radius 5px
    box-shadow 0 1px 15px 3px rgba(0, 0, 0, 0.16)
    background-color #fff
    background-image url(/static/img/black-twill.png)
    background-repeat repeat
    letter-spacing 1px
    position absolute
    z-index 99
    top -22px
    text-align center
    width 368px
    height 350px
    img
      display block
      margin 0 auto
    h3
      height 42px
      font-size 0
      margin 120px 0 64px 0
      ellipsis()
    .title__en
      font-size 14px
      ellipsis()
    .title__ch
      font-size 14px
      ellipsis()
  .detail-content
    margin 0
    padding 0
    position relative
    padding-left 408px
    h3
      margin 0
      padding 0
      letter-spacing 9px
      margin 0 0 25px 0
    .detail-summary
      color #2B9EFC
      letter-spacing 2px
      ellipsis()
    .details
      margin 31px 0 44px 0
      line-height 1.6
      height 66px
      overflow hidden
  .detailBtn-wrap
    padding-left 408px
    .detailBtn
      width 189px
      height 50px
      font-size 16px
      border-radius 5px
      font-family "Microsoft YaHei"
      letter-spacing 5px
      background rgb(43,158,252)
      border 1px solid rgb(43,158,252)
      color #fff
      border-top-style none
      border-right-style none
      border-bottom-style none
      border-left-style none
.row
  padding-top 90px
  padding-bottom 30px
.row .row-side
  clear both
  padding-left 0
  padding-right 30px
.row .text-center
  padding-left 75px
  margin-right 46px
  h1
    font-size 32px
    margin-bottom 5px
    float left
    margin-right 46px
.paragraph-wrapper
  border-top 0
  border none
  float left
  width 75%
  .item
    margin-top 25px
.paragraph-wrapper .item .item-title:before, .paragraph-wrapper .item .item-title:after
  content ''
  position absolute
  left -48px
  width 24px
  height 24px
  background-color transparent
  border 3px solid #2b9efc
  border-radius 3px
.paragraph-wrapper .item .item-title:before
  width 24px
  height 24px
  margin-top 5px
  margin-left 2px
  border-color rgba(43,158,252,0.65)
  box-shadow 0 0 10px 3px rgba(43,158,252,0.65), 0 0 3px 1px rgba(43,158,252,0.65) inset
.form-custom
  width 454px
.err-wrap
  padding 0 40px
</style>



// WEBPACK FOOTER //
// detail.vue?7bdbe640